<template>
    <div id="login">
        <div class="form-login popup">
            <div class="title-h1 text-center">
                {{$t("Archistoire")}}
            </div>
            <div class="mt-4">
                <input-text :placeholder="$t('Email')" v-model="email"></input-text>
                <input-password :placeholder="$t('Password')" v-model="password" @change="login"></input-password>
            </div>
            <div class="p-1" v-if="error !== ''" >
                <p class="help">
                    {{error}}
                </p>
            </div>
            <div class="text-right plr-2">
                <btn icon class="mt-4" dark @click="login">
                    <i class="fal fa-check"></i>
                    {{ $t("Connection") }}
                </btn>
            </div>
        </div>
    </div>
</template>

<script>
import InputText from "@/modules/input/input-text";
import InputPassword from "@/modules/input/input-password";
import Btn from "@/modules/buttons/btn";

export default {
    name: "Login",
    components: {Btn, InputText, InputPassword},
    data() {
        return {
            email: '',
            password: '',
            error:'',
        }
    },
    methods: {
        login() {
            this.error = ""
            this.$store.dispatch("AUTH_REQUEST", {email: this.email, password: this.password}).then(() => {
                // document.location.reload()
                this.$router.go()
            }).catch(err => {
                switch(err.response.status){
                    case 400:
                        this.error = this.$t('Login or password invalid');
                        break;
                    
                }
            })
        }
    }
}
</script>